import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '../Typography';
import './InsuranceVerificationDetails.scss';

type props = {
  estimatedCopay: string;
  className?: string;
};

export const InsuranceCopay: React.FC<props> = ({
  estimatedCopay,
  className,
}: props) => {
  const { t } = useTranslation('insuranceVerification');

  return (
    <div className={`card-container ${className || ''}`}>
      <Typography variant="size-18" color="color-2">
        {t('insuranceCopay.title')}
      </Typography>

      <Typography
        variant="size-26"
        weight="bold"
        color="color-2"
        className="mt-3"
      >
        {estimatedCopay} {t('insuranceCopay.amountSuffix')}
      </Typography>

      <Typography variant="size-14" color="color-28" className="mt-2">
        {t('insuranceCopay.description')}
      </Typography>
    </div>
  );
};
